// The interactive workflow board on the homepage.
//
// TWO THINGS THIS GETS RIGHT THAT THE FIRST VERSION DID NOT:
//
// 1. THE OTHER CARDS MOVE OUT OF THE WAY. The dragged card is physically re-inserted into the DOM
//    as the pointer passes each midpoint, so the gap follows you and you can see exactly where it
//    will land — the same way it behaves in the product. Reordering the DOM does not animate on
//    its own (a reflow is not a transition), so every card that shifted is FLIP-animated: measure
//    before, move, measure after, apply the inverse transform and release it. Without that the
//    cards teleport and it reads as broken even though it works.
//
// 2. POINTER EVENTS, NOT HTML5 DRAG-AND-DROP. HTML5 DnD does not fire on touch screens at all, and
//    half this audience is a shop owner holding a phone. Pointer events give mouse, trackpad,
//    touch and stylus one code path.
//
// Everything degrades: with this file missing you still get a readable board that scrolls
// sideways, because the scrolling is CSS.
(function () {
  var DRAG_THRESHOLD = 6;   // px before a press becomes a drag rather than a tap or a page scroll
  var EDGE = 70;            // px from the edge where dragging auto-scrolls the board
  var FLIP_MS = 170;

  function money(n) {
    return "$" + n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function init(board) {
    if (board.dataset.swBoardReady) return;
    board.dataset.swBoardReady = "1";

    var wrap = board.closest("[data-sw-board-wrap]") || board.parentElement;
    var reset = wrap.querySelector("[data-board-reset]");
    var hint = wrap.querySelector("[data-board-hint]");
    var allCards = function () { return [].slice.call(board.querySelectorAll("[data-card]")); };

    var original = allCards().map(function (card) {
      return { card: card, parent: card.parentElement, next: card.nextElementSibling };
    });

    // Every figure is rendered from its data value, so formatting lives in one place. Liquid has no
    // thousands separator worth using, and "$21924.92" beside "$52,190.00" looks like two products.
    [].forEach.call(board.querySelectorAll("[data-total]"), function (el) {
      el.setAttribute("data-value0", el.getAttribute("data-value"));
      el.textContent = money(parseFloat(el.getAttribute("data-value")) || 0);
    });
    [].forEach.call(board.querySelectorAll("[data-count]"), function (el) {
      el.setAttribute("data-count0", el.textContent.trim());
    });
    allCards().forEach(function (card) {
      var amt = card.querySelector("[data-amt]");
      if (amt) amt.textContent = money(parseFloat(card.getAttribute("data-amount")) || 0);
    });
    if (hint) hint.setAttribute("data-original", hint.textContent);

    function columnOf(el) { return el ? el.closest("[data-col]") : null; }

    // ---- FLIP ---------------------------------------------------------------
    /** Run a DOM move and animate every card that changed position because of it. */
    function flip(exclude, mutate) {
      var cards = allCards().filter(function (c) { return c !== exclude; });
      var before = cards.map(function (c) { return c.getBoundingClientRect(); });
      mutate();
      cards.forEach(function (c, i) {
        var a = c.getBoundingClientRect();
        var dx = before[i].left - a.left;
        var dy = before[i].top - a.top;
        if (!dx && !dy) return;
        c.style.transition = "none";
        c.style.transform = "translate(" + dx + "px," + dy + "px)";
        // Two frames: one to paint the inverted position, one to release it.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            c.style.transition = "transform " + FLIP_MS + "ms cubic-bezier(.2,.7,.3,1)";
            c.style.transform = "";
            setTimeout(function () { c.style.transition = ""; }, FLIP_MS + 30);
          });
        });
      });
    }

    function adjust(col, byCount, byAmount) {
      var countEl = col.querySelector("[data-count]");
      var totalEl = col.querySelector("[data-total]");
      if (countEl) {
        countEl.textContent = String(Math.max(0, (parseInt(countEl.textContent, 10) || 0) + byCount));
      }
      if (totalEl) {
        var v = Math.max(0, (parseFloat(totalEl.getAttribute("data-value")) || 0) + byAmount);
        totalEl.setAttribute("data-value", String(v));
        totalEl.textContent = money(v);
      }
      col.classList.add("is-changed");
      setTimeout(function () { col.classList.remove("is-changed"); }, 700);
    }

    /** Commit a column change: the figures on both columns have to end up telling the truth. */
    function settle(card, fromCol) {
      var toCol = columnOf(card);
      if (!fromCol || !toCol || fromCol === toCol) return;
      var amount = parseFloat(card.getAttribute("data-amount")) || 0;
      adjust(fromCol, -1, -amount);
      adjust(toCol, 1, amount);
      if (reset) reset.hidden = false;
      if (hint) hint.textContent = "That is the whole idea — the job moved, and the money moved with it.";
    }

    // ---- dragging -----------------------------------------------------------
    var drag = null;

    board.addEventListener("pointerdown", function (e) {
      if (e.target.closest("input, button, a, select")) return;
      var card = e.target.closest("[data-card]");
      if (!card || e.button > 0) return;
      drag = { card: card, x: e.clientX, y: e.clientY, active: false, id: e.pointerId };
    });

    window.addEventListener("pointermove", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x;
      var dy = e.clientY - drag.y;

      if (!drag.active) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        begin(e);
      }
      e.preventDefault();

      drag.ghost.style.transform =
        "translate(" + (e.clientX - drag.offX) + "px," + (e.clientY - drag.offY) + "px) rotate(1.5deg)";

      var box = board.getBoundingClientRect();
      if (e.clientX > box.right - EDGE) board.scrollLeft += 14;
      else if (e.clientX < box.left + EDGE) board.scrollLeft -= 14;

      // Where would it land right now? Move it there, so the gap follows the pointer.
      drag.ghost.style.pointerEvents = "none";
      var under = document.elementFromPoint(e.clientX, e.clientY);
      var drop = under && under.closest ? under.closest("[data-drop]") : null;
      if (!drop) return;

      var before = insertionPoint(drop, e.clientY, drag.card);
      var needsMove = drag.card.parentElement !== drop
        || (before ? drag.card.nextElementSibling !== before : drop.lastElementChild !== drag.card);
      if (!needsMove) return;

      flip(drag.card, function () {
        if (before) drop.insertBefore(drag.card, before);
        else drop.appendChild(drag.card);
      });
      highlight(drop);
    }, { passive: false });

    window.addEventListener("pointerup", function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      if (drag.active) {
        settle(drag.card, drag.fromCol);
        end();
      }
      drag = null;
    });

    window.addEventListener("pointercancel", function () {
      if (drag && drag.active) { settle(drag.card, drag.fromCol); end(); }
      drag = null;
    });

    function begin(e) {
      drag.active = true;
      drag.fromCol = columnOf(drag.card);
      var r = drag.card.getBoundingClientRect();
      drag.offX = e.clientX - r.left;
      drag.offY = e.clientY - r.top;

      var ghost = drag.card.cloneNode(true);
      ghost.classList.add("sw-lb__card--ghost");
      ghost.style.width = r.width + "px";
      ghost.style.transform = "translate(" + r.left + "px," + r.top + "px)";
      document.body.appendChild(ghost);

      drag.ghost = ghost;
      // The original stays in the flow as the gap — that is what makes the other cards move.
      drag.card.classList.add("is-dragging");
      document.body.classList.add("sw-lb-dragging");
    }

    function end() {
      if (drag.ghost) drag.ghost.remove();
      drag.card.classList.remove("is-dragging");
      document.body.classList.remove("sw-lb-dragging");
      highlight(null);
    }

    function highlight(drop) {
      [].forEach.call(board.querySelectorAll("[data-col]"), function (c) {
        c.classList.toggle("is-over", !!drop && c.contains(drop));
      });
    }

    /** The card the dragged one should sit above, judged on midpoints like the real board. */
    function insertionPoint(drop, y, moving) {
      var cards = [].filter.call(drop.querySelectorAll("[data-card]"), function (c) {
        return c !== moving && c.style.display !== "none";
      });
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        if (y < r.top + r.height / 2) return cards[i];
      }
      return null;
    }

    // ---- keyboard -----------------------------------------------------------
    var held = null;
    var live = document.createElement("p");
    live.className = "sw-visually-hidden";
    live.setAttribute("aria-live", "polite");
    wrap.appendChild(live);

    board.addEventListener("keydown", function (e) {
      var card = e.target.closest("[data-card]");
      if (!card) return;

      if (e.key === " " || e.key === "Enter") {
        e.preventDefault();
        if (held === card) { held = null; card.classList.remove("is-held"); live.textContent = "Dropped."; }
        else { held = card; card.classList.add("is-held"); live.textContent = "Picked up. Arrow keys to move it."; }
        return;
      }
      if (e.key === "Escape" && held) { held.classList.remove("is-held"); held = null; live.textContent = "Cancelled."; return; }
      if (!held) return;

      var cols = [].slice.call(board.querySelectorAll("[data-col]"));
      var fromCol = columnOf(held);

      if (e.key === "ArrowLeft" || e.key === "ArrowRight") {
        e.preventDefault();
        var next = cols[cols.indexOf(fromCol) + (e.key === "ArrowRight" ? 1 : -1)];
        if (!next) return;
        flip(held, function () { next.querySelector("[data-drop]").appendChild(held); });
        settle(held, fromCol);
        held.focus();
        next.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
        live.textContent = "Moved to " + next.querySelector(".sw-lb__coltitle").textContent + ".";
      } else if (e.key === "ArrowUp" || e.key === "ArrowDown") {
        // Reordering inside a column, which is most of what this gesture is used for.
        e.preventDefault();
        var sibs = [].slice.call(held.parentElement.querySelectorAll("[data-card]"));
        var i = sibs.indexOf(held);
        var target = sibs[i + (e.key === "ArrowDown" ? 1 : -1)];
        if (!target) return;
        flip(held, function () {
          if (e.key === "ArrowDown") target.after(held);
          else target.before(held);
        });
        held.focus();
        live.textContent = "Moved " + (e.key === "ArrowDown" ? "down" : "up") + ".";
      }
    });

    // ---- toolbar ------------------------------------------------------------
    var search = wrap.querySelector("[data-board-search]");
    var tagBoxes = [].slice.call(wrap.querySelectorAll("[data-filter-pop] input[type=checkbox]"));

    function applyFilters() {
      var q = (search && search.value || "").trim().toLowerCase();
      var tags = tagBoxes.filter(function (b) { return b.checked; }).map(function (b) { return b.getAttribute("data-tag"); });
      allCards().forEach(function (card) {
        var hay = (card.getAttribute("data-search") || "").toLowerCase();
        var tag = (card.getAttribute("data-tag") || "").toUpperCase();
        var okText = !q || hay.indexOf(q) !== -1;
        var okTag = !tags.length || tags.some(function (t) { return tag.indexOf(t) !== -1; });
        card.style.display = okText && okTag ? "" : "none";
      });
      board.classList.toggle("is-filtered", !!q || !!tags.length);
    }

    if (search) search.addEventListener("input", applyFilters);
    tagBoxes.forEach(function (b) { b.addEventListener("change", applyFilters); });

    var clear = wrap.querySelector("[data-filter-clear]");
    if (clear) clear.addEventListener("click", function () {
      tagBoxes.forEach(function (b) { b.checked = false; });
      if (search) search.value = "";
      applyFilters();
    });

    var toggle = wrap.querySelector("[data-filter-toggle]");
    var pop = wrap.querySelector("[data-filter-pop]");
    if (toggle && pop) {
      toggle.addEventListener("click", function (e) {
        e.stopPropagation();
        var open = pop.hidden;
        pop.hidden = !open;
        toggle.setAttribute("aria-expanded", String(open));
      });
      document.addEventListener("click", function (e) {
        if (!pop.hidden && !pop.contains(e.target) && e.target !== toggle) {
          pop.hidden = true;
          toggle.setAttribute("aria-expanded", "false");
        }
      });
    }

    var density = wrap.querySelector("[data-density]");
    if (density) density.addEventListener("click", function () {
      var on = board.classList.toggle("is-compact");
      density.setAttribute("aria-pressed", String(on));
    });

    // The view switch and column picker are presentation only in this preview — they still have to
    // respond to a click rather than feel dead.
    [].forEach.call(wrap.querySelectorAll("[data-view]"), function (btn) {
      btn.addEventListener("click", function () {
        [].forEach.call(wrap.querySelectorAll("[data-view]"), function (b) { b.classList.toggle("is-on", b === btn); });
        if (hint) hint.textContent = btn.getAttribute("data-view") === "list"
          ? "The list view lives in the software — this preview is the board."
          : hint.getAttribute("data-original");
      });
    });
    var colsBtn = wrap.querySelector("[data-columns-btn]");
    if (colsBtn) colsBtn.addEventListener("click", function () {
      if (hint) hint.textContent = "In the software you name these columns yourself — this is one shop's set.";
    });

    // ---- reset --------------------------------------------------------------
    if (reset) reset.addEventListener("click", function () {
      original.forEach(function (o) {
        if (o.next && o.next.parentElement === o.parent) o.parent.insertBefore(o.card, o.next);
        else o.parent.appendChild(o.card);
      });
      [].forEach.call(board.querySelectorAll("[data-total]"), function (el) {
        el.setAttribute("data-value", el.getAttribute("data-value0"));
        el.textContent = money(parseFloat(el.getAttribute("data-value0")) || 0);
      });
      [].forEach.call(board.querySelectorAll("[data-count]"), function (el) {
        el.textContent = el.getAttribute("data-count0");
      });
      reset.hidden = true;
      if (hint) hint.textContent = hint.getAttribute("data-original");
    });

    board.classList.add("sw-lb--ready");
  }

  function boot() { document.querySelectorAll("[data-sw-board]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", boot);
})();
